import { EmotionJSX } from "@emotion/react/types/jsx-namespace"
import { Box, Button, Typography } from "@mui/material"
import * as styles from "./ActiveRowItem.styles"

type Props = {
    name: string
    expanded: boolean
    onClick: () => void
    iconComponent: () => EmotionJSX.Element
}

export default function ActiveRowItem({
    name,
    expanded,
    onClick,
    iconComponent,
}: Props) {
    return (
        <Box css={styles.activeRowItem}>
            <Button style={{ cursor: "pointer" }} onClick={onClick}>
                <Box css={styles.rowItemContent}>
                    {iconComponent()}
                    {expanded ? (
                        <Typography variant="bodySmallBold">{name}</Typography>
                    ) : null}
                </Box>
            </Button>
        </Box>
    )
}
